import { warn } from "../core/config.js";

/**
 * The wordlist rides the same static mount as the bundle itself (src/app.ts
 * serves everything in dist/embed at /embed/v1), so the global CORS middleware
 * already covers the cross-origin fetch and no extra endpoint config is needed.
 */
export function wordlistUrl(endpoint: string): string {
  return `${endpoint.replace(/\/+$/, "")}/embed/v1/words-en.txt`;
}

let cached: Promise<readonly string[]> | null = null;

/**
 * Lazy, once-per-page load (~74 KB, only after a typeahead input is focused —
 * pages where nobody touches the search box never pay for it). On any failure
 * the promise resolves to [] after a single warning: no suggestions is a
 * degraded state, not an error state — typing and Enter keep working.
 */
export function loadWordlist(endpoint: string): Promise<readonly string[]> {
  cached ??= fetch(wordlistUrl(endpoint))
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then((text) =>
      text
        .split("\n")
        .map((w) => w.trim())
        .filter(Boolean),
    )
    .catch((error) => {
      warn("typeahead: wordlist failed to load — completion disabled.", error);
      return [];
    });
  return cached;
}
